// @ts-check

import React, { Component, Fragment } from "react"
import Button from "ui/legacy/Button"
import { selectAvailableProperties } from "../../attributes/items/properties"
import BroadcastItem from "../../broadcast/BroadcastItem"
import DisplayBroadcast from "../../broadcast/DisplayBroadcast"
import AvailableActions from "../../actions/AvailableActions"
import { selectPageAction } from "../../attributes/items/actions/pageActions"
import AvailableProperties from "../../properties/AvailableProperties"
import PropertyValue from "../../properties/PropertyValue"

/**
 * @augments {Component<BlockTypeProps, any>}
 */
export default class DebugPropertyBlockType extends Component {
    state = {}
    render() {
        const Wrapper = this.props.Wrapper

        return (
            <Wrapper
                {...this.props}
                style={{
                    borderRadius: 10,
                    border: "1px solid #CCC",
                    padding: 10,
                    margin: "0px 1px",
                }}
            >
                {({ attrs }) => (
                    <Fragment>
                        <div style={{ fontSize: "1.2em", marginBottom: 10 }}>
                            <u>Debug Properties / Actions</u>
                        </div>
                        <div className="display-flex">
                            <div
                                className="flex-1"
                                style={{
                                    border: "1px solid #DDD",
                                    background: "white",
                                    margin: 3,
                                    borderRadius: 5,
                                    padding: 5,
                                }}
                            >
                                <b>Property</b>
                                (<AvailableProperties>
                                    {properties => properties.length}
                                </AvailableProperties>)
                                <br />
                                {attrs.property ? (
                                    <PropertyValue id={attrs.property.id}>
                                        {value => (
                                            <BroadcastItem id={attrs.property.id}>
                                                {property => (
                                                    <Fragment>
                                                        name: <u>{property.name}</u>
                                                        <br />
                                                        published_name{" "}
                                                        <u>{property.published_name}</u>
                                                        <br />
                                                        type: {property.type}
                                                        <br />
                                                        value: {String(value)}
                                                        <br />
                                                        ownerBlockId:{" "}
                                                        <DisplayBroadcast broadcast={property} />
                                                    </Fragment>
                                                )}
                                            </BroadcastItem>
                                        )}
                                    </PropertyValue>
                                ) : (
                                    <em>Select a Property</em>
                                )}
                            </div>
                            <div
                                className="flex-1"
                                style={{
                                    border: "1px solid #DDD",
                                    background: "white",
                                    margin: 3,
                                    borderRadius: 5,
                                    padding: 5,
                                }}
                            >
                                <b>Action</b>
                                (<AvailableActions>
                                    {properties => properties.length}
                                </AvailableActions>)
                                <br />
                                {attrs.action ? (
                                    <BroadcastItem id={attrs.action.id}>
                                        {action => (
                                            <div>
                                                name: <u>{action.name}</u>
                                                <br />
                                                published_name <u>{action.published_name}</u>
                                                <br />
                                                ownerBlockId:{" "}
                                                <DisplayBroadcast broadcast={action} />
                                                <br />
                                                <Button type="primary" onClick={action.action}>
                                                    Run
                                                </Button>
                                            </div>
                                        )}
                                    </BroadcastItem>
                                ) : (
                                    <em>Select an action</em>
                                )}
                            </div>
                        </div>
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

DebugPropertyBlockType.attributes = [
    selectAvailableProperties({ field: "property", label: "select a property" }),
    selectPageAction({ field: "action", label: "what to do?" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/other/DebugProperty.js